import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { AREAS, AREAS_INDEX } from '../data/areas';
import { areasIndexJsonLd } from '../data/areaSchema';
import Seo from '../components/Seo';
import BrandName from '../components/BrandName';
import './AreaPage.css';

const postJobPath = (user) => {
  if (!user) return '/signup';
  if (user.type === 'provider') return '/provider-dashboard';
  return '/customer-dashboard';
};

const AreasIndexPage = () => {
  const { user } = useAuth();

  return (
    <div className="area-page">
      <Seo
        title={AREAS_INDEX.title}
        description={AREAS_INDEX.description}
        path={AREAS_INDEX.path}
        jsonLd={areasIndexJsonLd(AREAS_INDEX)}
      />

      <header className="area-hero">
        <div className="hero-bg-lines" aria-hidden="true" />
        <div className="area-hero-content">
          <div className="hero-eyebrow">South Wales</div>
          <h1>Rubbish removal <span>areas</span></h1>
          <p className="area-lead">
            The WasteGame is a new, free marketplace for household rubbish jobs in South Wales. These pages cover {AREAS.map((area) => area.name).join(', ').replace(/, ([^,]+)$/, ' and $1')}. Each one says how a job is posted, what people usually need collected there, and where that council explains fly-tipping and its own recycling centres.
          </p>
          <p className="area-lead">
            Posting is free. Registered waste carriers send a price if they want the work. You pay by card only after you accept a price and the job is marked complete. <BrandName inline /> does not add a customer fee, and a post is not a promise that anyone will take the job.
          </p>
        </div>
      </header>

      <div className="page-wrapper">
        <section className="area-block" aria-labelledby="towns-heading">
          <h2 id="towns-heading">Choose a <span>town</span></h2>
          <div className="area-index-grid">
            {AREAS.map((area) => (
              <Link key={area.slug} to={area.path} className="area-index-card">
                <div className="area-index-meta">{area.adminArea}</div>
                <h3>{area.name}</h3>
                <p>{area.card}</p>
              </Link>
            ))}
          </div>
        </section>

        <section className="area-card area-block">
          <h2>Same rules in every <span>town</span></h2>
          <div className="area-prose area-follow">
            <p>You describe the waste and create a free customer account if you do not have one. The street address goes on the job form so the carrier you choose can find it. It is not shown as a full address on the public listing.</p>
            <p>A price from a carrier is an offer. You can ignore it. Nothing is booked until you accept, and you might not receive a price at all. The WasteGame is new.</p>
            <p>On a priced job, payment is by card and only once the job is marked complete. You pay the price you accepted. There is no extra fee for the customer.</p>
          </div>
        </section>

        <section className="area-cta">
          <h2>Post your job <span>free</span></h2>
          <p>Pick a town above if you want the local notes first, or go straight to the job form.</p>
          <div className="area-cta-actions">
            <Link to={postJobPath(user)} className="btn btn-primary">Post your job free</Link>
            <Link to="/services" className="btn btn-secondary">View services</Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AreasIndexPage;
